import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "@/telemetry/appInsights";

export function AppInsightsRouteTracker() {
  const location = useLocation();

  useEffect(() => {
    trackPageView(`${location.pathname}${location.search}`);
  }, [location.pathname, location.search]);

  return null;
}
